'use strict';

var React = require('react');

/* Stores */
var ModuleInspectorStore = require('stores/module-inspector');

/* Components */
var TitledGroup = require('components/ui/titled-group');
var TextField = require('components/ui/text-field');

var ModuleInspectorPropertyTypeMultiText = React.createClass({
  displayName: 'ModuleInspectorPropertyTypeMultiText',

  getDefaultProps: function getDefaultProps() {
    return {
      value: []
    };
  },

  render: function render() {
    var component = this;
    var state = component.state;
    var props = component.props;

    var textNodes = [];
    var placeholderTranslation = ModuleInspectorStore.translate(props.groupName + '_' + props.name);
    var values = props.value || [];
    var count = values.length;

    for (var i = 0; i < count + 1; i++) {
      var value = values[i] || '';
      var descriptionTranslation = i === 0 ? '' : placeholderTranslation;
      textNodes.push(React.createElement(TextField, {
        key: i,
        value: value,
        ref: "textfield-" + i,
        disabled: props.disabled,
        placeholder: placeholderTranslation,
        description: descriptionTranslation,
        onChange: component._onChange }));
    }

    return React.createElement(
      TitledGroup,
      { className: 'multi-text-component', title: ModuleInspectorStore.translate(props.groupName + '_' + props.name) },
      textNodes
    );
  },

  _onChange: function _onChange(evt) {
    var component = this;
    var props = component.props;
    var values = [];
    var count = (props.value || []).length;

    for (var i = 0; i < count + 1; i++) {
      var value = component.refs['textfield-' + i].value;
      if (value.length) {
        values.push(value);
      }
    }

    if (props.onChange) {
      /* Send original value and new value */
      props.onChange(props.values, values);
    }
  }
});

module.exports = ModuleInspectorPropertyTypeMultiText;


/** WEBPACK FOOTER **
 ** ../~/babel-loader!./js/components/project/playground/module/inspector/type/multi-text.js
 **/